module.exports = __webpack_public_path__ + "static/story-wines-532f6cae9300cfa4dec8e7ec05faf5da.jpg";